var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button is-large the",style:({ backgroundColor: _vm.backgroundColor }),on:{"click":_vm.click}},[_c('span',{staticClass:"icon is-large"},[_c('i',{staticClass:"fa fa-chevron-up",style:({ color: _vm.color })})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ddf61108","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/JumpToTop.vue
// module id = EqyH
// module chunks = 1